import React from 'react';
import {
    Button,
    FormGroup,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';
import '../../EngagementMeetingsScheduling/MeetingShedulingWeekView/EngagementMeetingCancelModal/EngagementMeetingCancelModal.scss';

export interface DeleteSupportMeetingModalProps {
    isVisible: boolean;
    meetingName: string;
    isDeleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteSupportMeetingModal = (
    props: DeleteSupportMeetingModalProps
) => {
    return (
        <Rodal
            visible={props.isVisible}
            onClose={props.onClose}
            width={498}
            centered
            className="engagement-meeting-cancellation-modal">
            <ModalHeader>Remove Meeting</ModalHeader>
            <FormGroup>
                <ModalBody>
                    <div className="cancellation-modal-content">
                        <span>
                            Are you sure you want to remove the meeting{' '}
                            <b>{props.meetingName}</b>?
                        </span>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="button"
                        className="btn-cancel"
                        onClick={props.onClose}>
                        Cancel
                    </Button>
                    <ButtonLoader
                        disabled={props.isDeleting}
                        className="btn btn-primary"
                        buttonText="Confirm"
                        loaderButtonText="Confirm"
                        isLoading={props.isDeleting}
                        onClick={props.onConfirm}
                    />
                </ModalFooter>
            </FormGroup>
        </Rodal>
    );
};
